import { NetworkError, ValidationError, errorFromResponse } from "./errors.js";

export async function importProjectFinancials(csv, mode) {
  if (!["preview", "apply"].includes(mode)) throw new ValidationError("Mode must be preview or apply");
  let response;
  try {
    response = await fetch("/api/projects/financials-import", {
      method: "POST", credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ csv, mode }),
    });
  } catch (error) {
    throw new NetworkError(mode === "apply"
      ? "Import outcome unknown - refresh Financials and preview again before retrying."
      : `Network error: ${error?.message || error}`);
  }
  if (!response.ok) throw await errorFromResponse(response);
  try { return await response.json(); }
  catch (error) {
    if (mode === "apply") throw new NetworkError("Import outcome unknown - refresh Financials and preview again before retrying.");
    throw error;
  }
}
